import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6 4a2 2 0 0 1 2-2h10l4 4v10.2a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M10 2v4h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 18v-7h-8v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 22H4a2 2 0 0 1-2-2V6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SaveAll";
const SaveAll = memo(themed(Icon));
export {
  SaveAll
};
//# sourceMappingURL=save-all.js.map
